import { render, staticRenderFns } from "./InstagramFollowBooster.vue?vue&type=template&id=0990a8c2&scoped=true"
import script from "./InstagramFollowBooster.vue?vue&type=script&lang=js"
export * from "./InstagramFollowBooster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990a8c2",
  null
  
)

export default component.exports